import { VehicleInspectionsEffects } from './vehicle-inspections.effects';

export const featureEffects = [VehicleInspectionsEffects];
